
<div id="SeacrhDiv">
  <!-- <div class="col-sm-12 mt-sm-5" *ngIf="!pageType && !registerSuccess">
    <div class="heading-missingpets mt-3" id="heading-missingpets">
      <h1>{{ 'Siste savnet og funnet i Norge' | translate}}</h1>
      <p class="d-none d-sm-block">{{ 'Siste savnet og funnet i Norge Description1' | translate}} <br />
        {{ 'Siste savnet og funnet i Norge Description2' | translate}} </p>
    </div>
  </div> -->
  <!-- for search page  -->
  <div class="row">
    <div class="col-sm-12" *ngIf="registerSuccess">
      <div style="margin-bottom: 20px;margin-top: 0;margin-bottom: 1rem;margin-left: 22px;font-size: 20px;">
        <p *ngIf="pageType =='lost'">{{'Se andre savnede dyr av samme dyreart i ditt område'
          }}</p>
        <p *ngIf="pageType =='found'">{{ 'Se andre funnet dyr av samme dyreart i ditt område' }}
        </p>
      </div>
      <!-- <div class="heading-missingpets" id="heading-missingpets" style="text-align: left;">
        <h1> ({{petDetailsList?.length}})</h1>
      </div> -->
    </div>
  </div>

  <div class="col-sm-12" *ngIf="pageType">
    <div class="heading-missingpets" id="heading-missingpets">
      <h1 *ngIf="pageType =='found'">Funnet kjæledyr ({{petDetailsList?.length}})</h1>
      <h1 *ngIf="pageType =='lost'">Savnet kjæledyr ({{petDetailsList?.length}})</h1>
    </div>
  </div>
</div>
<div #searchfilterdiv class="row search-fltmt-b5 my-3 searchfilterdiv" *ngIf="!registerSuccess">
  <div class="col-sm-12">
    <div class="filter d-none d-xl-block">
      <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="search-inner-form">
        <div class="list-filter">
          <div class="search-filter" *ngIf="isDesktopView">
            <input type="text" (click)="handleClear()" class="pr-4" placeholder="Søk etter område/postnummer" (keydown.enter)="$event.preventDefault()"
              formControlName="Area" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search />
            <span class="search-icn"><i class="fas fa-search"></i></span>
          </div>
          <div class="list-map-view">
            <div class="list-action">
              <ul>
                <li class="mr-1" [ngClass]="!ListMap ? 'active' : ''"><a href="javascript:void(0)"
                    (click)="changeListMapView('List')" alt=""><i class="fas fa-bars"></i> Liste</a></li>
                <li [ngClass]="ListMap ? 'active' : ''"><a href="javascript:void(0)"
                    (click)="changeListMapView('ListMap')" alt=""><i class="fas fa-map-marker-alt"></i> Kart</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="missing-filter">
          <div class="col">
            <button type="button" (click)="changeOperationType( 1, $event)" class="btn width-100"
              [ngClass]="(OperationTypeID == 1) ? 'btn-filter2' : 'btn-whitebg'">Savnet</button>
          </div>
          <div class="col">
            <button type="button" (click)="changeOperationType( 2, $event)" class="btn btn-whitebg width-100"
              [ngClass]="(OperationTypeID == 2 ) ? 'btn-filter' : 'btn-whitebg'">Funnet</button>
          </div>
          <div class="col">
            <span class="bothfilter-opt">
              <select class="form-control" formControlName="SpeciesTypeValue" (change)="changeSpeciesType()">
                <option value="" selected disabled>{{'Choose Type' | translate }}</option>
                <option value="1">{{ 'Dog' | translate }}</option>
                <option value="2">{{ 'Cat' | translate }}</option>
                <option value="">{{ 'All' | translate }}</option>
              </select>
            </span>
          </div>
        </div>
      </form>
    </div>

    <div class="filter filtermbl d-xl-none">
      <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="search-inner-form">
        <div class="width-100 mb-2">
          <div class="list-map-view">
            <div class="list-action">
              <ul>
                <li (click)="changeListMapView('List')" class="mr-1" [ngClass]="MobileList ? 'active' : ''"><a
                    href="javascript:void(0)" alt=""><i class="fas fa-bars"></i> Liste</a></li>
                <li (click)="changeListMapView('ListMap')" [ngClass]="!MobileList ? 'active' : ''"><a
                    href="javascript:void(0)" alt=""><i class="fas fa-map-marker-alt"></i> Kart</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div class="width-100 mb-2">
          <div class="mlbbutton">
            <button type="button" (click)="changeOperationType( 1, $event)" class="btn width-100 mr-1"
              [ngClass]="(OperationTypeID == 1) ? 'btn-secondary' : 'btn-whitebg'">Savnet</button>
            <button type="button" (click)="changeOperationType( 2, $event)" class="btn width-100  ml-1"
              [ngClass]="(OperationTypeID == 2 ) ? 'btn-secondary' : 'btn-whitebg'">Funnet</button>
          </div>
        </div>

        <div class="width-100 mb-2">
          <div class="d-flex">
            <div class="bothfilter-opt width-100 mr-1">
              <select class="form-control" formControlName="SpeciesTypeValue" (change)="changeSpeciesType()">
                <option value="" selected>{{'Choose Type' | translate }}</option>
                <option value="1">{{ 'Dog' | translate }}</option>
                <option value="2">{{ 'Cat' | translate }}</option>
                <option value="">{{ 'All' | translate }}</option>
              </select>
            </div>
            <!-- <div class="bothfilter-opt width-100 ml-1">
            <select class="form-control">
              <option selected="">10 m</option>
              <option>20 m</option>
              <option>30 m</option>
              <option>40 m</option>
              <option>50 m</option>
            </select>
          </div> -->
          </div>
        </div>
        <!-- <div class="search-filter">
        <input type="text" class="pr-4" placeholder="Søk etter område/zip" (keydown.enter)="$event.preventDefault()"
          formControlName="Area" autocorrect="off" autocapitalize="off" spellcheck="off" type="text" #search />
        <span class="search-icn"><i class="fas fa-search"></i></span>
      </div> -->

        <div class="width-100">
          <div class="search-geo">
            <div class="search-filter" *ngIf="!isDesktopView">
              <input type="text" class="pr-4" (click)="handleClear()" placeholder="Søk etter område/postnummer"
                (keydown.enter)="$event.preventDefault()" formControlName="Area" autocorrect="off" autocapitalize="off"
                spellcheck="off" type="text" #search />
              <span class="search-icn"><i class="fas fa-search"></i></span>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
<div *ngIf="(recordFiltered == 0 ? true : false)"
  style="text-align: left; margin-bottom: 10px; font-size: 20px;font-family: 'Inter', sans-serif;font-weight: 400;">
  <span>Ingen dyr meldt i søkeområde. Viser resultater for Oslo området.</span>
</div>



<div id="listmap-section panel-container-vertical" class="row listmap-sectionmb-3" *ngIf="ListMap">
  <div class="col-sm-12">
    <div class="row">      
      <div #ListMap class="col-sm-6 mb-2 floatingList height">
        <div #Dragbar id="dragbar" style="display: none;"
        (touchmove)="ontouchmove($event)" >
          <hr class="topHr">             
        </div>
        <!-- product list start -->
        <div #ProductList class="product-list floatingProductList">
          <div class="text-center" *ngIf="loader">
            <button class="btn" type="button" disabled>
              <span class="spinner-border" role="status" aria-hidden="true"></span>
              <span style="display: block;">{{ 'Laster' | translate}} </span>
            </button>
          </div>
          <!-- product-content starts -->
          <div>
            <div class="" *ngFor="let petDetail of petDetailsList; ">
              <div class="product-content"
                [ngClass]="(petDetail.OperationTypeID == 2) ? 'lostdarkgreen' : 'lostlightgreen'">
                <div class="product-imgsec">
                  <div class="product-image" *ngIf="petDetail.ThumbnailImagePath && !petDetail.IsNeighbourPet">
                    <div (click)="goToPetDetails(petDetail)">
                      <img src="{{ petDetail.ThumbnailImagePath }}" (error)="errorHandler($event)"
                        class="img-fluid" alt="194x228">
                      <div class="product-tag"> <span class="prod-name">{{ ((petDetail.OperationTypeID =="1") ? 'Lost' :
                          'Found')| translate}} </span>
                      </div>
                    </div>
                  </div>
                  <div class="product-image" *ngIf="petDetail.IsNeighbourPet">
                    <div (click)="goToPetDetails(petDetail)">
                      <img src="{{ petDetail.ThumbnailImagePath }}" (click)="goToPetDetails(petDetail)"
                        (error)="errorHandler($event)" class="img-fluid" alt="194x228">
                      <!-- <div class="dyreid_tag" *ngIf="petDetail.CompanyLogo">
                        <img src="{{ petDetail.CompanyLogo }}" alt="80x70" class="img-fluid" />
                      </div> -->
                      <div class="product-tag">
                        <span class="prod-name">
                          Registrert
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="product-desc" (click)="goToPetDetails(petDetail)">
                  <div class="product-description">
                    <div class="open-detail-click">
                    </div>
                    <h2><span>{{petDetail.PostTitle}} </span></h2>
                    <div [ngClass]="(petDetail.OperationTypeID == 2 ) ? 'breadnamelightgreen' : 'breadname'"
                      *ngIf="petDetail.MasterBreed">
                      {{ 'Breed' | translate }}: {{petDetail.MasterBreed}}
                    </div>
                    <div>
                      <div class="details-btm">
                        <div class="area">{{ 'Area' | translate}}: {{petDetail.ZipCode}} {{petDetail.City}} </div>
                        <div class="datelogo">
                          <div class="date" *ngIf="!petDetail.IsNeighbourPet">Dato: {{ petDetail.LostFoundDate | date:
                            'dd.MM.yyyy'}}</div>
                          <div class="companylogo" *ngIf="petDetail.CompanyLogo">
                            <img src="{{ petDetail.CompanyLogo }}" alt="80x70" class="img-fluid" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="more-sec">
                      <button type="button" class="btn btn-whitebgbodr">Les mer</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-sm-6 mb-2" id="primary-content-wrap">
        <div class="map-view" *ngIf="markers && markers.length > 0 && (isDesktopView || !MobileList)">
          <agm-map (mapClick)="close_window()" [latitude]="lat" [longitude]="lng" [zoom]="zoom" [styles]="styles"
            [streetViewControl]="false">
            <agm-marker-cluster
              imagePath="https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m">
              <agm-marker *ngFor="let m of markers; let i = index" (markerClick)="clickedMarker('fgf', i, infoWindow )"
                [latitude]="m.lat" [longitude]="m.lng" [iconUrl]="m.customMarker" [label]="" [markerDraggable]="false">
                <agm-info-window #infoWindow>
                  <div class="info-boxx" (click)="goToPetDetails(m)">
                    <!-- <img *ngIf="m.petImgUrl" (error)="errorHandler($event)" src="{{m.petImgUrl }}" alt="Image"
                      class="boxx-img"><br>
                    <img *ngIf="m.PetPhoto" (error)="errorHandler($event)" src="{{m.PetPhoto}}" alt="Image"
                      class="boxx-img">
                    <img *ngIf="m.ThumbImagePath && !m.PetPhoto" (error)="errorHandler($event)"
                      src="{{ petImagePath + m.ThumbImagePath }}" alt="Image" class="boxx-img"><br> -->

                    <img *ngIf="m.IsNeighbourPet" (error)="errorHandler($event)" src="{{m.ThumbnailImagePath }}"
                      alt="Image" class="boxx-img"><br>
                    <img *ngIf="m.ThumbnailImagePath && !m.IsNeighbourPet" (error)="errorHandler($event)"
                      src="{{ m.ThumbnailImagePath }}" alt="Image" class="boxx-img">
                    <strong>{{m.PostTitle}} </strong>
                  </div>
                </agm-info-window>
              </agm-marker>
            </agm-marker-cluster>
          </agm-map>

          <!-- <div class="h-icon" ><span class="symbol"><img src="assets/img/h-icon.png" alt="" class="img-fluid"></span></div>
        <div class="k-icon" ><span class="symbol"><img src="assets/img/k-icn.png" alt="" class="img-fluid"></span></div> -->
        </div>
      </div>
    </div>
  </div>
</div>





<div id="list-section" class="mb-5" *ngIf="!ListMap">
  <div class="row">
    <div class="col-sm-12">
      <!-- product list start -->
      <div class="product-list">
        <div class="text-center" *ngIf="loader">
          <button class="btn" type="button" disabled>
            <span class="spinner-border" role="status" aria-hidden="true"></span>
            <span style="display: block;">{{ 'Laster' | translate}}</span>
          </button>
        </div>
        <!-- product-content starts -->
        <div class="row height">
          <div class="col-sm-6"
            *ngFor="let petDetail of petDetailsList; let i = index; let odd = odd; let even = even;">
            <div class="product-content"
              [ngClass]="(petDetail.OperationTypeID == 2) ? 'lostdarkgreen' : 'lostlightgreen'">
              <div class="product-imgsec">
                <div class="product-image" *ngIf="petDetail.ThumbnailImagePath && !petDetail.IsNeighbourPet">
                  <div (click)="goToPetDetails(petDetail)">
                    <img src="{{ petDetail.ThumbnailImagePath }}" (click)="goToPetDetails(petDetail)"
                      (error)="errorHandler($event)" class="img-fluid" alt="194x228">
                    <!-- <div class="dyreid_tag" *ngIf="petDetail.CompanyLogo">
                      <img src="{{ petDetail.CompanyLogo }}" alt="80x70" class="img-fluid" />
                    </div> -->
                    <div class="product-tag"> <span class="prod-name">{{ ((petDetail.OperationTypeID =="1") ? 'Lost' :
                        'Found')| translate}} </span>
                    </div>
                  </div>
                </div>
                <div class="product-image" *ngIf="petDetail.IsNeighbourPet">
                  <div (click)="goToPetDetails(petDetail)">
                    <img src="{{ petDetail.ThumbnailImagePath }}" (click)="goToPetDetails(petDetail)"
                      (error)="errorHandler($event)" class="img-fluid" alt="194x228">
                    <!-- <div class="dyreid_tag" *ngIf="petDetail.CompanyLogo">
                      <img src="{{ petDetail.CompanyLogo }}" alt="80x70" class="img-fluid" />
                    </div> -->
                    <div class="product-tag">
                      <span class="prod-name">
                        Registrert
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="product-desc" (click)="goToPetDetails(petDetail)">
                <div class="product-description">
                  <div class="open-detail-click">
                  </div>
                  <h2>{{petDetail.PostTitle}} </h2>
                  <!-- <div class="area">Område:{{ (petDetail.Area == null) ? "" : petDetail.Area }}  
                    {{ ((petDetail.ZipCode == null) ? "" : petDetail.ZipCode) +" "+((petDetail.City == null) ? "" : petDetail.City)}}
                  </div> -->
                  <div class="details-btm">
                    <div class="area"> {{ 'Area' | translate}}: {{petDetail.ZipCode}} {{petDetail.City}} </div>
                    <div class="datelogo">
                      <div class="date" *ngIf="!petDetail.IsNeighbourPet">Dato: {{ petDetail.LostFoundDate | date:
                        'dd.MM.yyyy'}}</div>
                      <div class="companylogo" *ngIf="petDetail.CompanyLogo">
                        <img src="{{ petDetail.CompanyLogo }}" alt="80x70" class="img-fluid" />
                      </div>
                    </div>
                    <!-- <div class="date" *ngIf="petDetail.IsNeighbourPet">Dato: {{ petDetail.UpdatedDate | date: 'dd.MM.yyyy'}}</div> -->
                  </div>
                  <div class="more-sec">
                    <button type="button" class="btn btn-whitebgbodr">Les mer</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- product-content end -->
      </div>
      <!-- product list end -->
    </div>
  </div>
</div>

<div id="bottomContent" class="row  mb-md-5 mb-3" *ngIf="!pageType">
  <div class="spellling-point col-sm-12">
    <div class="col-sm-12">
      <div class="selling-heading">
        <h2>Savnet & Funnet fra DyreID</h2>
      </div>

      <div class="selling-para">
        <ul>
          <li>Savnet & Funnet er fullintegrert med DyreIDs ID-database på 800.000 kjæledyr.</li>
          <li>Dyreeiere kan enkelt logge seg inn på Min Side og melde sitt dyr som savnet</li>
          <li>Den som finner et dyr kan enkelt melde det inn uten å være en registrert bruker hos oss fra før</li>
          <li>Raskt og enkelt - alle data vil være forhåndsutfylt med de lagrede data vi har på dyr og eier</li>          
          <li>DyreIDs publikumssøk på <a style="color:blue;text-decoration:underline;" href="https://www.dyreid.no"
              target="_blank">www.dyreid.no</a> blir brukt over 250.000 ganger pr år
          </li>
          <li>Samarbeider med Viking, Med Hjerte for hunder på rømmen, veterinærklinikker</li>
        </ul>
        <div class="footerlogodiv" style="margin-top: 30px;">
          <img src="assets/img/LOGO UTEN KONTO_InPixio.png" width="300" class="footerlogo">
          <img src="assets/img/Picture1.png" class="footerlogo">
        </div>
      </div>
    </div>
  </div>
</div>

<!-- for search page -->
<div class="row mb-5" *ngIf="pageType">
  <div class="spellling-pointt">
    <div class="col-sm-7">
      <div class="selling-heading">
        <h2>Finner du ikke dyret i listen?</h2>
      </div>
    </div>
    <div class="col-sm-5">
      <div class="callto-action">
        <a (click)="routeToPage()" class="btn btn-white width-100 mb-2 scroll-btn" type="btn">
          Meld dyret som {{pageType == 'lost' ? 'funnet' : 'savnet'}} <i class="fas fa-arrow-right"></i></a>
      </div>
    </div>
  </div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
  <p style="color: white">{{'Please Wait.'| translate}} </p>
</ngx-spinner>